import { useQuery } from '@tanstack/react-query'
import { api } from '../api'

export function useAuth() {
  return useQuery({
    queryKey: ['me'],
    queryFn: api.me,
    staleTime: 5 * 60_000,
  })
}
